import { getRealUser, isSimulation } from 'src/core/classes/helpers/StorageHelper'

import { HUB_AUDIT, hubPool } from '../classes/ws/signalr/HubPool'

type TObjectType = 'page' | 'widget' | 'component'

interface IObjectParams {
  name: string
  duration: number
  created?: number
  renderCount?: number
  typeState?: string
  isLongMeasure?: boolean
}

interface IFullObjectParams extends IObjectParams {
  isSimulation: boolean
  realUser: string
}

interface ISendAnalytics {
  objectId: string
  objectType: TObjectType
  objectParams: IObjectParams
}

export const sendAnalytics = async (data: ISendAnalytics, userEmail: string) => {
  const isSim = isSimulation()
  const realUser = isSim ? getRealUser() : userEmail

  const objectParams: IFullObjectParams = { ...data.objectParams, isSimulation: isSim, realUser }

  const payload = {
    objectId: data.objectId,
    objectType: data.objectType,
    objectParams: JSON.stringify(objectParams),
    startTime: new Date(),
    endTime: new Date(),
    status: 'success',
  }

  const hub = hubPool.getHub(HUB_AUDIT)

  await hub?.ready
  hub?.call('add', payload)
}
